import { Box, SxProps } from "@mui/material";
import { checkIfContentEmpty } from "../../utils/tiptap";
import { sanitizeHtml } from "../../utils/sanitizeHtml";

type Props = {
  html?: string;
  sx?: SxProps;
};

/** Renders TipTap HTML saved from the landing page builder. */
const LandingRichText = ({ html, sx }: Props) => {
  if (!html?.trim() || checkIfContentEmpty(html)) {
    return null;
  }

  return (
    <Box
      className="tiptap-text landing-rich-text"
      sx={sx}
      dangerouslySetInnerHTML={{ __html: sanitizeHtml(html) }}
    />
  );
};

export default LandingRichText;
